import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=a574bdd4&scoped=true&"
import script from "./EventDetail.vue?vue&type=script&lang=js&"
export * from "./EventDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=a574bdd4&prod&lang=css&"
import style1 from "./EventDetail.vue?vue&type=style&index=1&id=a574bdd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a574bdd4",
  null
  
)

export default component.exports